module.exports = __webpack_public_path__ + "img/logo-wheezo-vert.b254035c.svg";